import React from 'react';
import PropTypes from 'prop-types';
import WidgetCarousel from '../../components/widgets/WidgetCarousel';
import DimensionCard from './DimensionCard';

const DimensionsRow = (props) => {
    const { dimensions, loading } = props;

    const dimensionCards = dimensions.map((dimension) => (
        <div key={dimension._id}>
            <DimensionCard dimension={dimension} className={'col-12'} loading={loading} />
        </div>
    ));
    return (
        <div className={'dimensions-row-widget col-12'}>
            <WidgetCarousel
                className={'dimensions-carousel vertical-cards'}
                displayItems={dimensionCards}
                carouselSettings={'verticalCards-4.2'}
                cardOrientation={'vertical'}
                cardClassName={'col-12'}
            />
        </div>
    );
};

DimensionsRow.propTypes = {
    dimensions: PropTypes.array,
    loading: PropTypes.bool
};

export default DimensionsRow;
